import { FormControl } from '@angular/forms';
import { minStartupRAM } from 'wizards/steps/archive-consistency-step/consistency-step.utils';

export const MaxDiskCapacity = 4096;

export enum ProvisionModeEnum {
  lazy = 0,
  eager = 1,
  thin = 2
}

export type VmSettingsStepValueForm = {
  vmName: FormControl<string>;
  numCPU: FormControl<number>;
  memorySize: FormControl<number>;
  datastore?: FormControl<string>;
  diskProvision?: FormControl<ProvisionModeEnum>;
  virtualNetwork?: FormControl<string>;
  guestOs?: FormControl<string>;
  powerOn: FormControl<boolean>;

  destination?: FormControl<string>;
  dynamic?: FormControl<boolean>;
  generation?: FormControl<boolean>;
  overwrite?: FormControl<boolean>;
  maxMemorySize?: FormControl<number>;
  minMemorySize?: FormControl<number>;

  vmId?: FormControl<string>;
  cardModel?: FormControl<number>;
};

export type VmSettingsStepValue = {
  vmName: string;
  powerOn: boolean;
  numCPU: number;
  memorySize: number;
  datastore?: string;
  diskProvision?: ProvisionModeEnum;
  virtualNetwork?: string;
  guestOs?: string;

  destination?: string;
  dynamic?: boolean;
  generation?: boolean;
  overwrite?: boolean;
  maxMemorySize?: number;
  minMemorySize?: number;

  vmId?: string;
  cardModel?: number;

  valid: boolean;
};

export const DefaultVmSettingsStepValue = {
  vmName: '',
  numCPU: 2,
  memorySize: 4096,
  datastore: '',
  diskProvision: ProvisionModeEnum.thin,
  virtualNetwork: '',
  guestOs: '',
  powerOn: false,

  dynamic: false,
  generation: false,
  overwrite: false,
  maxMemorySize: 4096,
  minMemorySize: minStartupRAM,
  vmId: '',
  cardModel: 0,
  valid: true
};
